<template>
  <div class="container index">
    <Header :active="0"></Header>
    <swiperBox></swiperBox>
    <Achievement></Achievement>
    <Advantage></Advantage>
    <Software></Software>
    <Cartoon></Cartoon>
    <Case></Case>
    <Partner :title="'服务伙伴'"></Partner>
    <Contact></Contact>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
// import swiperBox from '../components/carousel/index'
import swiperBox from '../components/swiper/index'
import Achievement from '../components/Section/section0'
import Advantage from '../components/Section/section1'
import Software from '../components/Section/section2'
import Cartoon from '../components/Section/section3'
import Case from '../components/Section/section4'
import Partner from '../components/Section/section5'
import Contact from '../components/Section/section6'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    swiperBox,
    Achievement,
    Advantage,
    Software,
    Cartoon,
    Case,
    Partner,
    Contact,
    Position,
    Footer
  },
  data() {
    return {}
  },
}
</script>
